export default "__VITE_ASSET__8fb798e8__"